export default "__VITE_ASSET__2LLzriRR__"